import { Navigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { logger } from '@/utils/logger' // Added logger import
import { useAuth } from '@/hooks/common/useAuth'
import { isEmailVerified } from '@/utils/firebaseAuth'
import { auth } from '@/utils/firebaseConfig'

interface PrivateRouteProps {
  children: React.ReactNode
}

export function PrivateRoute({ children }: PrivateRouteProps) {
  const { user, loading } = useAuth()
  const [isFirebaseReady, setIsFirebaseReady] = useState(false)

  // Wait for Firebase auth to be ready before checking email verification
  useEffect(() => {
    const checkFirebaseReady = () => {
      if (auth.currentUser !== null) {
        setIsFirebaseReady(true)
      }
    }

    // Check immediately
    checkFirebaseReady()

    // Set up listener for auth state changes
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        setIsFirebaseReady(true)
      } else {
        setIsFirebaseReady(false)
      }
    })

    return () => unsubscribe()
  }, [])

  if (loading || (!isFirebaseReady && user)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  logger.debug('user', user)

  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Check if email verification is required (only after Firebase is ready)
  if (isFirebaseReady && !isEmailVerified()) {
    return <Navigate to="/verify-email" replace />
  }

  return <>{children}</>
}
